import { Box, Typography, useTheme } from '@mui/material';
import BreadcrumbNav from 'src/components/Navigation/BreadcrumbNav';
import { useDashboard } from 'src/context/dashboardContext';
import DashboardFilterBar from 'src/features/dashboard/components/DashboardFilterBar';
import { useAllGroupsMetrics } from 'src/features/dashboard/hooks/useAllGroupsMetrics';
import { LayoutTemplate } from 'src/features/dashboard/models/layouts';
import { formatDateTime } from 'src/utils/dateHelper';
import { LayoutSelector } from 'switch-fe-shared/components/Layout';

const TopBar = () => {
  const {
    availableLayoutOptions,
    currentTemplate,
    handleLayoutChange,
    isAllGroupsSelected,
  } = useDashboard();

  const { lastUpdated, isLoading, isFetching } = useAllGroupsMetrics();
  const theme = useTheme();

  return (
    <>
      <BreadcrumbNav
        showHome={false}
        actionControls={
          !isAllGroupsSelected ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <DashboardFilterBar />
              <LayoutSelector<LayoutTemplate>
                currentLayout={currentTemplate}
                layoutOptions={availableLayoutOptions}
                onLayoutChange={handleLayoutChange}
              />
            </Box>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant='body2'
                color={theme.tokens.colors.mutedForeground}
                fontSize={theme.tokens.typography.fontSize.xs}
              >
                {isLoading || isFetching
                  ? ''
                  : `Updated at ${formatDateTime(lastUpdated)}`}
              </Typography>
            </Box>
          )
        }
      />
    </>
  );
};

export default TopBar;
